import { useEffect, useMemo, useRef, useState } from "react";
import { isEmpty } from "lodash";
import { useNavigate, useParams } from "react-router-dom";
import AuthContext from "../../context/AuthContext";
import { useContextSelector } from "use-context-selector";
import BetSlipContext from "../../context/BetSlipContext";
import secureLocalStorage from "react-secure-storage";
import { motion } from "framer-motion";
import { useTabIndicator } from "../../component/useTabIndicator";
import ParlaySportbookInner from "./ParlaySportbookInner";
const ParlaySportbook = ({
  data,
  user,
  detail,
  profileData,
  setBetSlipObject,
  favouriteList,
  BetSlip,
  addToFavioute,
}) => {
  const parlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlyBet;
  });
  const betSlipObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.betSlipObject;
  });
  const showBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.showBetDialog;
  });
  const setShowBetDialog = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setShowBetDialog;
  });
  const setToastObject = useContextSelector(BetSlipContext, (ctx) => {
    return ctx.setToastObject;
  });

  const parlay = useContextSelector(AuthContext, (ctx) => {
    return ctx.parlay;
  });
  const setParlyBet = useContextSelector(AuthContext, (ctx) => {
    return ctx.setParlyBet;
  });

  const naviagte = useNavigate();
  const [header, setHeader] = useState("all");
  const [selected, setSelected] = useState("");
  const [active, setActive] = useState(
    Array.from({ length: 101 }, (_, i) => i),
  );
  const [localLimit, setLocalLimit] = useState({});
  const handelChange = (odds, item, res, e) => {
    if (!isEmpty(user)) {
      if (odds > 0) {
        setParlyBet((current) => {
          const newObj = {
            ...item,
            sportsBookSelectionObject: res,
            selectObj: res?.id,
            newEventId: detail?.eventId,
            eventName: detail?.eventName,
            marketId: detail?.marketId,
          };

          const currentList = current || [];

          const filteredList = currentList.filter(
            (temp) => temp?.newEventId !== detail?.eventId,
          );

          const updatedList = [...filteredList, newObj];

          secureLocalStorage.setItem("parlyBet", updatedList);

          return updatedList;
        });
      }
    } else {
      setToastObject({
        type: "warning",
        title: "Warning",
        message: "Please login to place your bet!",
        status: true,
      });
    }
  };
  useEffect(() => {
    let obj = profileData?.matchSetting?.find(
      (res) =>
        res?.type == "sportBook" &&
        (profileData?.arrayCheck == "details"
          ? true
          : res?.sportType == detail?.gameType),
    );
    if (!isEmpty(obj)) {
      setLocalLimit(obj);
    } else {
      setLocalLimit({
        maxAmount: 1000,
        maxProfit: 10000,
        minAmount: 1,
        oddsLimit: 10,
      });
    }
  }, []);

  const [updatedData, setUpdatedData] = useState([]);
  const reorderedData = useMemo(() => {
    if (!favouriteList?.length) return data || [];
    const favSet = new Set(favouriteList);
    return [
      ...data.filter((item) => favSet.has(item.id)),
      ...data.filter((item) => !favSet.has(item.id)),
    ];
  }, [data, favouriteList]);

  // ✅ Memoize filtered data based on header
  const filteredData = useMemo(() => {
    if (!reorderedData?.length) return [];
    const lowerCased = (str) => str?.toLowerCase() || "";

    switch (header) {
      case "Innings":
        return reorderedData.filter((res) =>
          lowerCased(res.marketName).includes("innings"),
        );
      case "Over":
        return reorderedData.filter((res) => {
          const name = lowerCased(res.marketName);
          return name.includes("over") && !name.includes("winner");
        });
      case "Match":
        return reorderedData.filter((res) => {
          const name = lowerCased(res.marketName);
          return name.includes("winner") || name.includes("innings");
        });
      case "Batsman":
        return reorderedData.filter((res) => {
          const name = lowerCased(res.marketName);
          return (
            !name.includes("over") &&
            name.includes("innings") &&
            name.includes("total")
          );
        });
      default:
        return reorderedData;
    }
  }, [reorderedData, header]);

  // ✅ Set filtered data when it changes
  useEffect(() => {
    setUpdatedData(filteredData);
  }, [filteredData]);

  // ✅ Handle bet slip updates cleanly
  useEffect(() => {
    if (!(betSlipObject?.playType === "sportBook" && showBetDialog)) return;

    if (!data?.length) {
      setBetSlipObject({});
      setShowBetDialog(false);
      return;
    }

    const find = data.find((res) => res?.id === betSlipObject?.item?.id);

    if (
      isEmpty(find) ||
      [9, 2, 3, 4].includes(Number(find?.marketStatus)) ||
      !find?.sportsBookSelection?.length
    ) {
      setBetSlipObject({});
      setShowBetDialog(false);
      return;
    }

    const updatedObject = find.sportsBookSelection.find(
      (res) => res.id === betSlipObject?.object?.id,
    );
    if (updatedObject?.odds !== betSlipObject?.odds) {
      setBetSlipObject((prev) => ({
        ...prev,
        object: { ...prev.object, odds: updatedObject?.odds },
        odds: updatedObject?.odds,
      }));
    }
  }, [betSlipObject, showBetDialog, data, setBetSlipObject, setShowBetDialog]);

  const { containerRef, setActiveIndex, indicatorStyle } = useTabIndicator(0);
  return (
    <div>
      <div
        data-v-251e1ccc
        className="s-h-40px s-flex s-items-center s-bg-primary"
        style={{
          "--30716420": `translateX(${indicatorStyle?.x || 10}px)`,
          "--1245c4b0": `${indicatorStyle?.width || 41}px`,
        }}
      >
        <div
          data-v-251e1ccc
          className="s-w-full s-overflow-x-scroll s-relative s-flex s-items-center s-pt-px s-h-full"
        >
          <div data-v-251e1ccc className="s-relative s-inline-block s-mr-2">
            <div
              ref={containerRef}
              data-v-251e1ccc
              className="s-w-full s-flex s-jusrify-center s-px-7px x s-cursor-pointer s-text-market-name s-text-16px s-font-bold"
            >
              {premiumCategoryArray?.map((res, index) => {
                return (
                  <span
                    onClick={() => {
                      setHeader(res?.type);
                      setActiveIndex(index);
                    }}
                    data-v-251e1ccc
                    name={res?.name}
                    className="s-font-bold s-text-center s-py-2 s-px-6px s-mx-3px"
                  >
                    {res?.name}
                  </span>
                );
              })}
            </div>
            <motion.div
              data-v-251e1ccc
              className="s-tab-indicator s-parlay s-absolute s-left-0 s-bottom-0 s-h-3px s-rounded-1.5px s-bg-market-name"
            />
          </div>
        </div>
        <span
          data-v-251e1ccc
          className="s-icon-info-circle s-block s-mx-2 s-w-16px s-h-16px s-text-16px s-text-market-sub-icon"
        />
      </div>
      {data?.length > 0 ? (
        <div className="s-px-2 s-py-2 s-pt-10px s-text-global-font-default-light dark:s-text-global-font-default-dark">
          <ParlaySportbookInner
            updatedData={updatedData}
            parly={parlay}
            betSlipObject={betSlipObject}
            handelChange={handelChange}
            setSelected={setSelected}
            BetSlip={BetSlip}
            showBetDialog={showBetDialog}
            favouriteList={favouriteList}
            selected={selected}
            parlyBet={parlyBet}
            detail={detail}
            active={active}
            setActive={setActive}
            addToFavioute={addToFavioute}
          />

          <div className="s-flex s-justify-center s-items-center s-pt-1 s-min-h-30px">
            <div className="s-flex s-flex-1 s-justify-end s-items-center">
              <div
                className="s-flex s-gap-3px s-items-center s-text-black-600 dark:s-text-black-400"
                data-testid="betLimit"
              >
                <span className="s-icon-min-max s-text-14px" />
                <span className="s-text-12px">Min</span>
                <span className="s-text-12px s-font-bold">90</span>
              </div>
            </div>
          </div>
        </div>
      ) : (
        detail?.hasSportBook &&
        detail?.premiumFancy == "on" && (
          <div class="s-bg-white s-rounded-b-xl dark:s-bg-market-tab-bg-active">
            <div class="s-bg-market-tab-active s-h-3px"></div>
            <div class="s-py-3 s-px-4 s-text-14px dark:s-text-black-500">
              Loading Market…
            </div>
          </div>
        )
      )}
    </div>
  );
};

export default ParlaySportbook;
const premiumCategoryArray = [
  { type: "all", name: "All" },
  { type: "Popular", name: "Popular" },
  { type: "Match", name: "Match" },
  { type: "Innings", name: "Innings" },
  { type: "Over", name: "Over" },
  { type: "Batsman", name: "Batsman" },
];
